//eslint-disable-next-line
export default {
  gutterBottom: {
    marginBottom: 8
  }
};
